import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import { TemplatePage } from '../../../../components/common/pager';
import { TemplateHeader } from '../../../../components/template/templateHeader';
import { TemplateInput } from '../../../../components/template/templateInput';
import { TemplateFormBuilderAnswers } from '../../../../components/template/templateFormBuilderAnswers';

import * as templateHelper from '../../../../components/template/templateHelper';

import { PartOneInfo } from '../components/partOneInfo';
import Button from '../../../../components/common/button';
import { SimpleProgressBar } from '../../../../components/common/SimpleProgressBar';
import { UrlWithCopy } from '../../../../components/common/UrlWithCopy';

import { paths } from '../constants/template';

export const getPartOneEditTab = (props) => {
  const {
    onChange,
    required,
    email,
    formBuilderAnswers,
    dateReceived,
    fundraiserRaisedAmount,
    fundraiserTargetAmount,
    fundraiserUrlFull,
    fundraiserId,
    fundraiserMinimumTargetAmount,
    organizationCurrency,
    organizationName,
    eventName,
    eventAmbassadorProgramName,
    onSave,
    onCancelEdit,
    isLoading,
    isApplicationPartTwoVisible
  } = props;

  return (
    <TemplatePage
      id="part-one"
      i18nKey={`${
        isApplicationPartTwoVisible
          ? 'applications.template.page.partOne.application-details-title'
          : 'applications.template.page.partOne.title'
      }`}
    >
      <TemplateHeader
        as="h2"
        label="applications.template.page.partOne.header-name.label"
      />

      <PartOneInfo
        dateReceived={dateReceived}
        fundraiserRaisedAmount={fundraiserRaisedAmount}
        eventName={eventName}
        eventAmbassadorProgramName={eventAmbassadorProgramName}
        organizationName={organizationName}
      />

      {fundraiserId && (
        <>
          <TemplateHeader
            as="h5"
            label="applications.template.page.partOne.fundraiser-details.label"
          />

          <div isolated className="template-view-container">
            <div className="field field-section">
              <label>{I18n.t('applications.template.page.partOne.fundraiser-details.page-url')}</label>
              <div className="field-value">
                <UrlWithCopy url={fundraiserUrlFull} />
              </div>
            </div>

            <div className="field field-section">
              <label>{I18n.t('applications.template.page.partOne.fundraiser-details.progress')}</label>
              <div className="field-value">
                <SimpleProgressBar
                  value={fundraiserRaisedAmount || 0}
                  target={fundraiserTargetAmount || 0}
                  minimumTargetAmount={fundraiserMinimumTargetAmount}
                  currency={organizationCurrency}
                  color="green"
                  size="small"
                  showPercentage={true}
                />
              </div>
            </div>
          </div>
        </>
      )}

      <TemplateHeader
        as="h5"
        label="applications.template.page.partOne.account-details-name.label"
      />

      <TemplateInput
        id="partOneFirstName"
        path={paths.FIRST_NAME}
        label="applications.template.page.partOne.first-name.label"
        onChange={onChange}
        validation={required}
      />

      <TemplateInput
        id="partOneLastName"
        path={paths.LAST_NAME}
        label="applications.template.page.partOne.last-name.label"
        onChange={onChange}
        validation={required}
      />

      <TemplateInput
        id="partOneEmail"
        path={paths.EMAIL}
        label="applications.template.page.partOne.email-name.label"
        onChange={onChange}
        validation={email}
      />

      <TemplateHeader
        as="h5"
        label="applications.template.page.partOne.event-questions-name.label"
      />

      <TemplateFormBuilderAnswers
        id="templateFormBuilderAnswers"
        path={paths.APPLICATION_ENTRY}
        disableTargetField
        onChange={onChange}
        validation={formBuilderAnswers}
      />

      <TemplateHeader
        as="h5"
        path={paths.OGRANIZATION_QUESTIONS_HEADER}
        label="applications.template.page.partOne.organization-questions-name.label"
      />

      <TemplateFormBuilderAnswers
        id="templateFormBuilderAnswers"
        path={paths.APPLICATION_ADDITIONAL}
        disableTargetField
        onChange={onChange}
        validation={formBuilderAnswers}
      />

      <TemplateHeader
        as="h2"
        path={paths.PART_TWO_HEADER}
        label="applications.template.page.partOne.part-two-header.label"
      />

      <TemplateFormBuilderAnswers
        id="templateFormBuilderAnswers"
        path={paths.APPLICATION_CONFIRMATION}
        disableTargetField
        onChange={onChange}
        validation={formBuilderAnswers}
      />

      <div path={paths.APPLY_BUTTON} className="template-button-container" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button
          style={{ minWidth: '100px' }}
          onClick={onCancelEdit}
        >
          <Translate value="general.cancel" />
        </Button>
        <Button
          primary
          style={{ minWidth: '100px' }}
          onClick={onSave}
          loading={isLoading}
          disabled={isLoading}
        >
          <Translate value="general.save" />
        </Button>
      </div>
    </TemplatePage>
  );
};
